/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { SimpliCityApp } from "app";
import { reportWebVitals } from "./reportWebVitals";
import { Logger } from "cms/utils/logger";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

const rootElement = document.getElementById("root");
const isProduction = !process.env.NODE_ENV || process.env.NODE_ENV !== "development";
Logger.debug(`ENVIRONMENT: ${process.env.NODE_ENV}`);

// /**
//  * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
//  * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
//  */
// const msalInstance = new PublicClientApplication(msalConfig);
//
// // Default to using the first account if no account is active on page load
// if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
//     // Account selection logic is app dependent. Adjust as needed for different use cases.
//     msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
// }
//
// // Listen for sign-in event and set active account
// msalInstance.addEventCallback((event) => {
//     Logger.debug(`MSAL EVENT: ${event.eventType}`);
//     if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
//         const account = event.payload.account;
//         console.info(`${JSON.stringify(account)}`);
//         // debugger
//         msalInstance.setActiveAccount(account);
//     }
//     if (event.eventType === EventType.LOGIN_FAILURE) {
//         console.error(event.error);
//         // debugger
//     }
// });

if (isProduction) {
    // production
    Logger.debug("Production build for hydration.");
    if (rootElement.hasChildNodes()) {
        ReactDOM.hydrateRoot(rootElement, <SimpliCityApp
            // instance={msalInstance}
        />);
    } else {
        const root = ReactDOM.createRoot(rootElement);
        root.render(<SimpliCityApp
            // instance={msalInstance}
        />);
    }
} else {
    // dev uses strict mode (possible double renders)
    Logger.debug("Development mode.");
    if (rootElement.hasChildNodes()) {
        ReactDOM.hydrateRoot(rootElement, <React.StrictMode><SimpliCityApp
            // instance={msalInstance}
        /></React.StrictMode>);
    } else {
        const root = ReactDOM.createRoot(rootElement);
        root.render(<React.StrictMode><SimpliCityApp
            // instance={msalInstance}
        /></React.StrictMode>);
    }
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
